import { render, staticRenderFns } from "./TabView.vue?vue&type=template&id=25b5254e&scoped=true"
import script from "./TabView.vue?vue&type=script&lang=js"
export * from "./TabView.vue?vue&type=script&lang=js"
import style0 from "./TabView.vue?vue&type=style&index=0&id=25b5254e&prod&lang=scss&scoped=true"
import style1 from "./TabView.vue?vue&type=style&index=1&id=25b5254e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b5254e",
  null
  
)

export default component.exports